export type TimeEntry = {
  id: string;
  client: string;
  company_name?: string;
  offer: string | null;
  rate: string | null;
  rate_label: string;
  hourly_rate: string | null;
  description: string;
  started_at: string;
  ended_at: string | null;
  user_email: string;
  invoice: string | null;
  hours: string;
  amount: string | null;
  is_running: boolean;
  is_locked: boolean;
};

export type DirectMonth = {
  period: string;
  package_amount: string;
  hours: string;
  hours_amount: string;
  total: string;
  currency: string;
  sent_at: string | null;
  sent_total: string | null;
};

export type DirectContract = {
  offer_id: string;
  title: string;
  client_id: string;
  company_name: string;
  currency: string;
  package: string | null;
  ended_at: string | null;
  months: DirectMonth[];
};

export type AdvisorInvoiceRow = {
  invoice_id: string;
  invoice_number: string;
  billing_period: string;
  customer_organization_id: string;
  customer_name: string;
  currency: string;
  status: string;
  paid_at: string | null;
  due_date: string;
  my_share: string;
  processing_fee: string;
  my_net: string;
  lines: { description: string; quantity: string; unit_price: string; total_price: string }[];
};

export type BalanceRow = {
  currency: string;
  earned: string;
  fees: string;
  net: string;
  paid_out_or_requested: string;
  available: string;
};

export type ProcessingFee = {
  rate_percent: string;
  since: string | null;
  upcoming: { rate_percent: string; effective_from: string; announced_at: string | null } | null;
};

export function ratePercent(value: string) {
  return `${parseFloat(value).toString()}%`;
}

export function dayLabel(iso: string) {
  return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });
}

export type PayoutRequest = {
  id: string;
  amount: string;
  currency: string;
  invoice_filename: string;
  note: string;
  status: 'requested' | 'paid' | 'rejected';
  status_display: string;
  requested_at: string;
  resolved_at: string | null;
  resolution_note: string;
};

export type BillingSummary = {
  invoices: AdvisorInvoiceRow[];
  balance: BalanceRow[];
  payouts: PayoutRequest[];
};

export function periodLabel(period: string) {
  const [year, month] = period.split('-').map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
}

export function hoursLabel(hours: string | number) {
  const value = typeof hours === 'string' ? parseFloat(hours) : hours;
  if (!value) return '0h';
  const whole = Math.floor(value);
  const minutes = Math.round((value - whole) * 60);
  return minutes ? `${whole}h ${minutes}m` : `${whole}h`;
}
